import type { Timestamp } from '@bufbuild/protobuf/wkt'

/**
 * Convert protobuf BigInt to JavaScript Number
 * Use this for display purposes only
 */
export function bigIntToNumber(value: bigint | number | undefined): number {
  if (value === undefined) return 0
  if (typeof value === 'number') return value
  return Number(value)
}

/**
 * Convert protobuf Timestamp to JavaScript Date
 */
export function timestampToDate(timestamp: Timestamp | undefined): Date | null {
  if (!timestamp) return null
  if (!timestamp.seconds && timestamp.seconds !== 0n) return null
  
  // Timestamp has seconds (bigint) and nanos (number) fields
  // Convert bigint seconds to number for Date constructor
  const seconds = typeof timestamp.seconds === 'bigint' 
    ? Number(timestamp.seconds) 
    : timestamp.seconds
  
  const nanos = timestamp.nanos || 0
  const milliseconds = seconds * 1000 + nanos / 1000000
  
  // Check if the resulting date is valid
  const date = new Date(milliseconds)
  return isNaN(date.getTime()) ? null : date
}

/**
 * Format timestamp as string
 */
export function formatTimestamp(timestamp: Timestamp | undefined): string {
  const date = timestampToDate(timestamp)
  if (!date) return 'Unknown'
  return date.toLocaleString()
}

/**
 * Format timestamp as ISO string
 */
export function timestampToISO(timestamp: Timestamp | undefined): string {
  const date = timestampToDate(timestamp)
  if (!date) return ''
  return date.toISOString()
}
